import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useMatch } from 'react-router-dom';
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import CookieConsent from "./Components/CookieConsent/CookieConsent";
import Home from './Pages/Home';
import LoginSignup from "./Pages/LoginSignup";
import VerifyEmail from './Components/VerifyEmail/VerifyEmail';
import ResendVerification from './Components/VerifyEmail/ResendVerification';
import EmailVerified from './Components/VerifyEmail/EmailVerified';
import VerificationError from './Components/VerifyEmail/VerificationError';
import UserDashboard from "./Pages/Dashboard";
import ProductTemplate from './Pages/ProductTemplate';
import SyncX from './Pages/SyncX';
import AvisoLegal from './Pages/AvisoLegal';
import PoliticaPrivacidad from './Pages/PoliticaPrivacidad';
import PoliticaCookies from './Pages/PoliticaCookies';
import ConfiguracionCookies from './Pages/ConfiguracionCookies';
import CameraMonitorPopup from './Pages/CameraMonitorPopup';
import Launcher from './Pages/Launcher';
import LandingPage from './Pages/LandingPage';
import PaymentSuccess from './Pages/PaymentSuccess';
import PaymentError from './Pages/PaymentError';

function App() {
  const [user] = useState(null);
  const [pageReady, setPageReady] = useState(false); // 🆕 page readiness flag

  return (
    <Router>
      <AppContent user={user} setPageReady={setPageReady} pageReady={pageReady} />
    </Router>
  );
}

function AppContent({ user, setPageReady, pageReady }) {
  const isProductPage = useMatch('/product/:productId');
  const isSyncxPage = useMatch('/Syncx/*');
  const isCameraMonitorPopup = useMatch('/camera-monitor-popup');
  const isLauncherPage = useMatch('/intoreality-vr-launcher');
  const hideNavbarFooter = isProductPage || isSyncxPage || isCameraMonitorPopup || isLauncherPage;

  return (
    <div className="App">
      {!hideNavbarFooter && <Navbar user={user} />}
      <Routes>
        <Route path="/" element={<Home setPageReady={setPageReady} />} />
        <Route path="/intoreality-vr-launcher" element={<Launcher />} />
        <Route path="/account" element={<LoginSignup isInline={true} />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/resend-verification" element={<ResendVerification />} />
        <Route path="/email-verified" element={<EmailVerified />} />
        <Route path="/verification-error" element={<VerificationError />} />
        <Route path="/Dashboard" element={<UserDashboard />} />
        <Route path="/product/:productId" element={<ProductTemplate />} />
        <Route path="/syncx/*" element={<SyncX />} />
        <Route path="/camera-monitor-popup" element={<CameraMonitorPopup />} />
        <Route path="/aviso-legal" element={<AvisoLegal />} />
        <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
        <Route path="/politica-cookies" element={<PoliticaCookies />} />
        <Route path="/configuracion-cookies" element={<ConfiguracionCookies />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-error" element={<PaymentError />} />
        <Route path="/:slug" element={<LandingPage />} />
      </Routes>
      {/* Only delay footer rendering on home */}
      {!hideNavbarFooter && <Footer user={user} />}
      <CookieConsent />
    </div>
  );
}

export default App;
